export default "__VITE_ASSET__CbmKDorF__"